module.exports = __webpack_public_path__ + "static/media/panorama.28e090f3.png";